import React, { Component } from "react";
import { Input } from "reactstrap";
import { Search, MapPin } from "react-feather";
import { Link } from "react-router-dom";
import SearchResults from "react-filter-search";
//IMG
import FilterBottomSheets from "views/job-listing/components/FilterBottomSheets";
import bookmark from "views/job-listing/img/bookmark.svg";
import search from "views/job-listing/img/search.png";
import pin from "views/job-listing/img/pin.svg";
import moment from "moment";
import filter from "views/job-listing/img/filter.png";
import img from "views/job-listing/img/phoneofficer.png";
import Token from "api/Auth/auth";
import store from "store.js";
import { setMgToken, setHcToken } from "store/Auth";
import { connect } from "react-redux";
import { AddBookmarkACTION } from "store/Bookmark";
import { getAllSearchResultsAction, mainGroupAction } from "store/JobList";

class AllJobs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      jobs: [
        {
          id: 1,
          img: require("views/job-listing/img/privilagebanker.png"),
          title: "Privilege Banker",
          experience: "1-3 years",
          education: "CA",
          location: "Mumbai",
          day: "3d ago",
        },
        {
          id: 2,
          img: require("views/job-listing/img/phoneofficer.png"),
          title: "Phone Banking Officer",
          experience: "1-3 years",
          education: "CA",
          location: "Mumbai",
          day: "3d ago",
        },
        {
          id: 3,
          img: require("views/job-listing/img/wealthmanager.png"),
          title: "Wealth Manager",
          experience: "1-3 years",
          education: "CA",
          location: "Mumbai",
          day: "3d ago",
        },
        {
          id: 4,
          img: require("views/job-listing/img/privilagebanker.png"),
          title: "Privilege Banker",
          experience: "1-3 years",
          education: "CA",
          location: "Mumbai",
          day: "3d ago",
        },
        {
          id: 5,
          img: require("views/job-listing/img/inform-architech.png"),
          title: "Information Architech",
          experience: "1-3 years",
          education: "CA",
          location: "Mumbai",
          day: "3d ago",
        },
        {
          id: 6,
          img: require("views/job-listing/img/salesmanager.png"),
          title: "Sales Manager",
          experience: "1-3 years",
          education: "CA",
          location: "Mumbai",
          day: "3d ago",
        },
        {
          id: 7,
          img: require("views/job-listing/img/securittyenginner.png"),
          title: "Security Engineer",
          experience: "1-3 years",
          education: "CA",
          location: "Mumbai",
          day: "3d ago",
        },
        {
          id: 8,
          img: require("views/job-listing/img/inform-architech.png"),
          title: "Information Architech",
          experience: "1-3 years",
          education: "CA",
          location: "Mumbai",
          day: "3d ago",
        },
        {
          id: 9,
          img: require("views/job-listing/img/privilagebanker.png"),
          title: "Privilege Banker",
          experience: "1-3 years",
          education: "CA",
          location: "Mumbai",
          day: "3d ago",
        },
        {
          id: 10,
          img: require("views/job-listing/img/phoneofficer.png"),
          title: "Phone Banking Officer",
          experience: "1-3 years",
          education: "CA",
          location: "Mumbai",
          day: "3d ago",
        },
        {
          id: 11,
          img: require("views/job-listing/img/wealthmanager.png"),
          title: "Wealth Manager",
          experience: "1-3 years",
          education: "CA",
          location: "Mumbai",
          day: "3d ago",
        },
        {
          id: 12,
          img: require("views/job-listing/img/privilagebanker.png"),
          title: "Privilege Banker",
          experience: "1-3 years",
          education: "CA",
          location: "Mumbai",
          day: "3d ago",
        },
        {
          id: 5,
          img: require("views/job-listing/img/inform-architech.png"),
          title: "Information Architech",
          experience: "1-3 years",
          education: "CA",
          location: "Mumbai",
          day: "3d ago",
        },
        {
          id: 6,
          img: require("views/job-listing/img/salesmanager.png"),
          title: "Sales Manager",
          experience: "1-3 years",
          education: "CA",
          location: "Mumbai",
          day: "3d ago",
        },
        {
          id: 7,
          img: require("views/job-listing/img/securittyenginner.png"),
          title: "Security Engineer",
          experience: "1-3 years",
          education: "CA",
          location: "Mumbai",
          day: "3d ago",
        },
        {
          id: 8,
          img: require("views/job-listing/img/inform-architech.png"),
          title: "Information Architech",
          experience: "1-3 years",
          education: "CA",
          location: "Mumbai",
          day: "3d ago",
        },
      ],
      filter: false,
      search: "",
      location: "",
      category: "",
      maingroup: "",
      keyword: "",
      experience: "",
    };

    this.bottomSheet = React.createRef();
  }
  async onBookMark(ev, id) {
    // ev.target.src =
    let payload = {
      user_id: this.props.Auth.MGID,
      job_id: id,
    };
    let response = await this.props.AddBookmark(payload);
    // if(response.ResponseCode == 100){
    //   // ev.target.src = defaultjob;
    // }
  }
  onInputChange = (event) => {
    this.setState({
      keyword: event.target.value,
      maingroup: event.target.value,
    });

    if (this.state.keyword.length >= 3 && this.state.maingroup.length >= 3) {
      this.searchJob(this.state.keyword, this.state.maingroup);
    } else {
      //
    }
  };

  async searchJob(keyword, maingroup) {
    let payload = {
      userId: 1,
      keyword: keyword,
      maingroup: maingroup,
    };
    let getAllSearchResponse = await this.props.getAllSearchResultsAction(
      payload
    );
  }

  //console.log(state.DETAILS.details.SearchResult)

  async componentDidMount() {
    //    let HcToken = await Token.getToken();
    // store.dispatch(setHcToken(HcToken));
    // let MgToken = await Token.getTokenMagitt();
    // store.dispatch(setMgToken(MgToken));
  }
  addDefaultSrc(ev) {
    ev.target.src = img;
  }

  handleFilter() {
    if (window.innerWidth > 575) {
      this.setState({ filter: !this.state.filter });
    } else {
      this.bottomSheet.current.toggleBottomSheet();
    }
  }

  render() {
    const { jobs } = this.props;
    return (
      <div>
        <FilterBottomSheets ref={this.bottomSheet} />
        <div className=" pb-8 lg:pt-16 md:pt-16 pt-0 lg:px-0 md:px-0 px-4 lg:mt-0 md:mt-0 mt-4">
          <div className="button-section flex sm-reverse-btn">
            <button
              className="filter-btn flex justify-center items-center font-semibold fsize16 lg:mr-8 md:mr-8"
              onClick={() => this.handleFilter()}
            >
              <p className="mr-3 ">FILTERS</p>
              <img src={filter} alt="filter" />
            </button>

            <h2 className="fsize28 font-bold uppercase text-black sm-fsize16">
              ALL JOBS
            </h2>
          </div>

          <div className="mt-10 flex">
            {this.state.filter && (
              <div className="filter lg:w-1/4 md:w-1/4 w-3/5 pr-6">
                <card className="rounded-12px drop-shadow20px block p-6 ">
                  <div className="flex justify-between">
                    <h1 className="fsize18 text262626 font-semibold">
                      Filters
                    </h1>
                    <p className="fsize16 textE77817 underline  ">Clear all</p>
                  </div>

                  <div className="relative  mt-6 mb-8">
                    <Search
                      width="18"
                      height="18"
                      className="absolute filter-searchicon"
                    />
                    <Input
                      type="text"
                      name="keyword"
                      className="w-full cust-shadow-md py-3 pl-12 pr-4 text#4B4B4B opacity-60per fsize14 rounded-full "
                      placeholder="Search..."
                      value={this.state.keyword}
                      onChange={this.onInputChange}
                    />
                  </div>
                  {this.props.searchresult
                    ? this.props.searchresult
                      ? this.props.searchresult.Data
                        ? this.props.searchresult.Data.map((value, index) => {
                            return <div>{value.f_title} </div>;
                          })
                        : ""
                      : ""
                    : ""}

                  <div className="mb-6">
                    <h1 className="fsize16 text262626 font-semibold">
                      Job Type
                    </h1>
                    <div className="mt-4">
                      <div className="flex justify-between mb-1">
                        <div className="flex items-center ">
                          {/* <input type="checkbox" className="w-18px h-18px " /> */}
                          <label class="custcheckbox">
                            <p className="text262626 fsize14 opacity-80per ml-2">
                              Full-Time
                            </p>
                            <input type="checkbox" checked />
                            <span class="overhide-span"></span>
                          </label>
                        </div>
                        <p className="text262626 fsize14 opacity-80per ml-2">
                          16
                        </p>
                      </div>
                      <div className="flex justify-between">
                        <div className="flex items-center ">
                          {/* <input type="checkbox" className="w-18px h-18px " /> */}
                          <label class="custcheckbox">
                            <p className="text262626 fsize14 opacity-80per ml-2">
                              Part-Time
                            </p>
                            <input type="checkbox" checked />
                            <span class="overhide-span"></span>
                          </label>
                        </div>
                        <p className="text262626 fsize14 opacity-80per ml-2">
                          8
                        </p>
                      </div>

                      <div className="flex justify-between">
                        <div className="flex items-center ">
                          {/* <input type="checkbox" className="w-18px h-18px " /> */}
                          <label class="custcheckbox">
                            <p className="text262626 fsize14 opacity-80per ml-2">
                              Remote
                            </p>
                            <input type="checkbox" />
                            <span class="overhide-span"></span>
                          </label>
                        </div>
                        <p className="text262626 fsize14 opacity-80per ml-2">
                          8
                        </p>
                      </div>

                      <div className="flex justify-between">
                        <div className="flex items-center ">
                          {/* <input type="checkbox" className="w-18px h-18px " /> */}
                          <label class="custcheckbox">
                            <p className="text262626 fsize14 opacity-80per ml-2">
                              Intenship
                            </p>
                            <input type="checkbox" />
                            <span class="overhide-span"></span>
                          </label>
                        </div>
                        <p className="text262626 fsize14 opacity-80per ml-2">
                          8
                        </p>
                      </div>

                      <div className="flex justify-between">
                        <div className="flex items-center ">
                          {/* <input type="checkbox" className="w-18px h-18px " /> */}
                          <label class="custcheckbox">
                            <p className="text262626 fsize14 opacity-80per ml-2">
                              Contract
                            </p>
                            <input type="checkbox" />
                            <span class="overhide-span"></span>
                          </label>
                        </div>
                        <p className="text262626 fsize14 opacity-80per ml-2">
                          5
                        </p>
                      </div>

                      <div className="flex justify-between">
                        <div className="flex items-center ">
                          {/* <input type="checkbox" className="w-18px h-18px " /> */}
                          <label class="custcheckbox">
                            <p className="text262626 fsize14 opacity-80per ml-2">
                              Training
                            </p>
                            <input type="checkbox" />
                            <span class="overhide-span"></span>
                          </label>
                        </div>
                        <p className="text262626 fsize14 opacity-80per ml-2">
                          2
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* category */}
                  <div className="mb-6">
                    <h1 className="fsize16 text262626 font-semibold">
                      Category
                    </h1>
                    <div className="mt-4">
                      {this.props.maingroup
                        ? this.props.maingroup.Data.map((value, index) => (
                            <div className="flex justify-between mb-1">
                              <div className="flex items-center ">
                                {/* <input type="checkbox" className="w-18px h-18px " /> */}
                                <label class="custcheckbox">
                                  <p className="text262626 fsize14 opacity-80per ml-2">
                                    {value.g_title}
                                  </p>
                                  <input type="checkbox" />
                                  <span class="overhide-span"></span>
                                </label>
                              </div>
                              <p className="text262626 fsize14 opacity-80per ml-2">
                                16
                              </p>
                            </div>
                          ))
                        : ""}
                    </div>
                  </div>

                  {/* location */}
                  <div className="mb-6">
                    <div className="relative  mt-6 mb-4">
                      <MapPin
                        width="18"
                        height="18"
                        className="absolute  filter-searchicon"
                      />
                      <Input
                        type="text"
                        name="location"
                        className="w-full cust-shadow-md text#4B4B4B opacity-60per py-3 pl-12 pr-4  fsize14 rounded-full "
                        placeholder="Find Location"
                        value={this.state.location}
                        onChange={(e) => {
                          this.setState({ location: e.target.value });
                        }}
                      />
                    </div>
                    <div className="mt-4">
                      <div className="flex justify-between mb-1">
                        <div className="flex items-center ">
                          {/* <input type="checkbox" className="w-18px h-18px " /> */}
                          <label class="custcheckbox">
                            <p className="text262626 fsize14 opacity-80per ml-2">
                              New Delhi
                            </p>
                            <input type="checkbox" checked />
                            <span class="overhide-span"></span>
                          </label>
                        </div>
                        <p className="text262626 fsize14 opacity-80per ml-2">
                          2
                        </p>
                      </div>
                      <div className="flex justify-between">
                        <div className="flex items-center ">
                          {/* <input type="checkbox" className="w-18px h-18px " /> */}
                          <label class="custcheckbox">
                            <p className="text262626 fsize14 opacity-80per ml-2">
                              Mumbai
                            </p>
                            <input type="checkbox" checked />
                            <span class="overhide-span"></span>
                          </label>
                        </div>
                        <p className="text262626 fsize14 opacity-80per ml-2">
                          9
                        </p>
                      </div>

                      <div className="flex justify-between">
                        <div className="flex items-center ">
                          {/* <input type="checkbox" className="w-18px h-18px " /> */}
                          <label class="custcheckbox">
                            <p className="text262626 fsize14 opacity-80per ml-2">
                              Banglore
                            </p>
                            <input type="checkbox" />
                            <span class="overhide-span"></span>
                          </label>
                        </div>
                        <p className="text262626 fsize14 opacity-80per ml-2">
                          6
                        </p>
                      </div>

                      <div className="flex justify-between">
                        <div className="flex items-center ">
                          {/* <input type="checkbox" className="w-18px h-18px " /> */}
                          <label class="custcheckbox">
                            <p className="text262626 fsize14 opacity-80per ml-2">
                              Chennai
                            </p>
                            <input type="checkbox" />
                            <span class="overhide-span"></span>
                          </label>
                        </div>
                        <p className="text262626 fsize14 opacity-80per ml-2">
                          5
                        </p>
                      </div>

                      <div className="flex justify-between">
                        <div className="flex items-center ">
                          {/* <input type="checkbox" className="w-18px h-18px " /> */}
                          <label class="custcheckbox">
                            <p className="text262626 fsize14 opacity-80per ml-2">
                              Kannur
                            </p>
                            <input type="checkbox" />
                            <span class="overhide-span"></span>
                          </label>
                        </div>
                        <p className="text262626 fsize14 opacity-80per ml-2">
                          3
                        </p>
                      </div>
                      <div className="mt-1">
                        <p className="underline fsize16 text-orange-c ">
                          Show all
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* experience */}
                  <div className="mb-6">
                    <h1 className="fsize16 text262626 font-semibold">
                      Experience
                    </h1>
                    <div className="mt-4">
                      <div className="flex justify-between mb-1">
                        <div className="flex items-center ">
                          {/* <input type="checkbox" className="w-18px h-18px " /> */}
                          <label class="custcheckbox">
                            <p className="text262626 fsize14 opacity-80per ml-2">
                              0 - 2 Years
                            </p>
                            <input type="checkbox" checked />
                            <span class="overhide-span"></span>
                          </label>
                        </div>
                        <p className="text262626 fsize14 opacity-80per ml-2">
                          16
                        </p>
                      </div>
                      <div className="flex justify-between">
                        <div className="flex items-center ">
                          {/* <input type="checkbox" className="w-18px h-18px " /> */}
                          <label class="custcheckbox">
                            <p className="text262626 fsize14 opacity-80per ml-2">
                              2 - 5 Years
                            </p>
                            <input type="checkbox" checked />
                            <span class="overhide-span"></span>
                          </label>
                        </div>
                        <p className="text262626 fsize14 opacity-80per ml-2">
                          8
                        </p>
                      </div>

                      <div className="flex justify-between">
                        <div className="flex items-center ">
                          {/* <input type="checkbox" className="w-18px h-18px " /> */}
                          <label class="custcheckbox">
                            <p className="text262626 fsize14 opacity-80per ml-2">
                              5 - 7 Years
                            </p>
                            <input type="checkbox" />
                            <span class="overhide-span"></span>
                          </label>
                        </div>
                        <p className="text262626 fsize14 opacity-80per ml-2">
                          0
                        </p>
                      </div>

                      <div className="flex justify-between">
                        <div className="flex items-center ">
                          {/* <input type="checkbox" className="w-18px h-18px " /> */}
                          <label class="custcheckbox">
                            <p className="text262626 fsize14 opacity-80per ml-2">
                              5 - 7 Years
                            </p>
                            <input type="checkbox" />
                            <span class="overhide-span"></span>
                          </label>
                        </div>
                        <p className="text262626 fsize14 opacity-80per ml-2">
                          5
                        </p>
                      </div>

                      <div className="flex justify-between">
                        <div className="flex items-center ">
                          {/* <input type="checkbox" className="w-18px h-18px " /> */}
                          <label class="custcheckbox">
                            <p className="text262626 fsize14 opacity-80per ml-2">
                              10+ Years
                            </p>
                            <input type="checkbox" />
                            <span class="overhide-span"></span>
                          </label>
                        </div>
                        <p className="text262626 fsize14 opacity-80per ml-2">
                          2
                        </p>
                      </div>
                    </div>
                  </div>
                </card>
              </div>
            )}

            <div
              className={`all-jobscard lg:gap-6 md:gap-6 gap-4 grid  ${
                this.state.filter
                  ? "lg:w-3/4 md:w-3/4 w-2/5 lg:grid-cols-3 md:grid-cols-3 grid-cols-1"
                  : "w-full lg:grid-cols-4 md:grid-cols-4 grid-cols-2"
              }`}
            >
              {jobs ? (
                <SearchResults
                  value={this.state.search}
                  data={jobs}
                  renderResults={(jobs) => (
                    <>
                      {jobs.map((job, index) => {
                        return (
                          <card className="rounded-12px drop-shadow block ">
                            <div className="relative">
                              <img
                                onError={this.addDefaultSrc}
                                src={
                                  process.env.REACT_APP_IMAGE_BASE_MG +
                                  "/" +
                                  job.f_path
                                }
                                alt="jobs"
                                className="w-full min-maxh-121px sm-h95px rounded-t-12px"
                              />
                              <div className="absolute bookmark-parent text-white rounded-full">
                                <img
                                  onClick={(e) => {
                                    this.onBookMark(e, job.f_jobId);
                                  }}
                                  src={bookmark}
                                  alt="bookmark"
                                  className="bookmark-t-c"
                                />
                              </div>
                            </div>

                            <div className="lg:p-6 md:p-6 p-4">
                              <h1 className="fsize18 font-bold mob-fsize14">
                                {job.f_title}
                              </h1>

                              <div className="mt-2">
                                <div className="flex items-center lg:justify-start md:justify-start justify-between">
                                  <p className="fsize12 color-lgrey font-semibold">
                                    Required Experience:
                                  </p>
                                  <p className="text424B5A fsize12 mb-0 font-bold ml-1 whitespace-nowrap	">
                                    {job.Experience || "0"}
                                  </p>
                                </div>

                                <div className="flex items-center lg:justify-start md:justify-start justify-between mt-1">
                                  <p className="fsize12 color-lgrey font-semibold">
                                    Education:
                                  </p>
                                  <p className="text424B5A fsize12 mb-0 font-bold ml-1">
                                    {job.Education || "ANY"}
                                  </p>
                                </div>
                              </div>
                              <p className="dashed-border-b lg:mt-4 md:mt-4 mt-2"></p>
                              <div className="flex justify-start items-center lg:mt-4 md:mt-4 mt-2">
                                <div className="flex items-center mr-2">
                                  <img
                                    src={pin}
                                    alt="pin"
                                    className="pn-icon-w"
                                  />

                                  <p className="text-muted-400 ml-2">
                                    {job.Location || "UNKNOWN"}
                                  </p>
                                </div>
                                <div className="flex items-center">
                                  <span className="dot-point bg-bluecolor rounded-full mx-2"></span>
                                  <p className="text-muted-400">
                                    {moment(job.f_createdDate).fromNow()}
                                  </p>
                                </div>
                              </div>
                              <div className="mt-6 flex items-center mob-hidden">
                                <Link
                                  to={`/CareerApplicant/career/job-details/${job.f_jobId}`}
                                >
                                  <button className="orange-btn flex justify-center items-center font-semibold fsize12 mr-4">
                                    APPLY NOW
                                  </button>
                                </Link>
                                <Link
                                  to={`/CareerApplicant/career/job-details/${job.f_jobId}`}
                                >
                                  <p className="underline fsize14 text-orange-c ">
                                    View Details
                                  </p>
                                </Link>
                              </div>
                            </div>
                          </card>
                        );
                      })}
                    </>
                  )}
                />
              ) : (
                <h1>NO JOBS TO DISPLAY</h1>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    featuredjobs: state.Home.home.FEATUREDJOB,
    Auth: state.Auth.user,
    maingroup: state.DETAILS.details.MainGroup,
    searchresult: state.DETAILS.details.SearchResult,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAllSearchResultsAction: async (payload) => {
      await dispatch(getAllSearchResultsAction(payload));
    },
    mainGroupAction: async () => {
      await dispatch(mainGroupAction());
    },
    AddBookmark: async (payload) => await dispatch(AddBookmarkACTION(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(AllJobs);
